<div *ngIf="priceModel && priceModel.profile && priceModel.profile.isETF">
    <div class="row market-price-heading">
        <div class="col-sm-12">
            <h5 class="rps-heading-five">Current market price</h5>
            <p class="caption rps-paragraph-two rps-grey" data-rpa-tag-id="currentPriceDate">Current price as of
                {{priceModel?.delayedPrice?.quotes[0]?.equity?.tradingDates?.lastTradeDateTime | date:'E MMM dd HH:mm:ssz yyyy' | ESTPipe : false}}
            </p>
        </div>
    </div>
</div>

<div *ngIf="priceModel && priceModel.profile && priceModel.profile.isETF">
    <p class="hide-text-screenreader-only" aria-live="assertive" aria-atomic="true" id="livePriceUpdate"></p>
    <div class="row currentMarketPriceWrap">
        <div class="col-lg-3 col-sm-4 col-6">
            <div class="cell market-price-cell">
                <p class="rps-paragraph-two">
                    <a role="button" tabindex="0" class="link marketPriceLink dialog-button"
                        (click)="setDialogInfo('Market price','','');currentPriceModalDialog.openModalDialog();"
                        href="javascript:void(0)" aria-live="polite" aria-atomic="true" aria-relevant="text"
                        id="marketPriceLabel">
                        Market price</a>
                </p>
                <h2 class="mark-regular rps-heading-two" data-rpa-tag-id="priceMarket" id="priceMarket">
                    {{priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.lastTradePrice ?
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.lastTradePrice |
                    currency:'USD':'symbol':'1.2-2') : '&mdash;' }}</h2> <br />
                <p class="refresh-price-mobile vg-paragraph-two--bold">
                    <a [iconName]="'refresh'" role="button" c11n-link href="javascript:void(0)" (click)=" announcePrice(); refreshFunc();"
                        [attr.aria-label]="'Refresh last price'">
                        Refresh last price
                    </a>
                </p>
            </div>
        </div>

        <div class="col-lg-3 col-sm-4 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">Market price change</p>
                <div class="current-price-data-wrap">
                    <c11n-icon class="value-change-icon" data-rpa-tag-id="arrowMarket"
                        *ngIf="priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange > 0 || priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange < 0"
                        [name]="priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange | valueChange : 'name'"
                        [size]="'small'"
                        [altText]="priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange | valueChange : 'altText'">
                    </c11n-icon>
                    <span class="vg-heading-four--regular"
                        data-rpa-tag-id="priceChangeMarket_percentChangeMarket">{{priceModel?.delayedPrice?.quotes[0] ?
                        (priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange |
                        currency:'USD':'symbol':'1.2-2') : '&mdash;'}}
                        ({{priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.priceChangePercentToday ?
                        percentAppend((priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.priceChangePercentToday)) :
                        '&mdash;' }})
                    </span>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-sm-4 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">Open</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="openPrice">
                    {{priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.openPrice ?
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.openPrice
                    |currency:'USD':'symbol':'1.2-2') : '&mdash;' }}</h4>
            </div>
        </div>
        <div class="col-lg-2 col-sm-4 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">High</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="dayHighPrice">
                    {{priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.dayHighPrice ?
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.dayHighPrice
                    |currency:'USD':'symbol':'1.2-2') : '&mdash;' }}</h4>
            </div>
        </div>

        <div class="col-lg-2 col-sm-4 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">Low</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="dayLowPrice">
                    {{priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.dayLowPrice ?
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.dayLowPrice
                    |currency:'USD':'symbol':'1.2-2') : '&mdash;' }}</h4>
            </div>
        </div>
        <div class="col-lg-3 col-sm-4 col-6 empty-cell">
            <p class="refresh-price vg-paragraph-two--bold">
                <a [iconName]="'refresh'" role="button" c11n-link href="javascript:void(0)" (click)="announcePrice(); refreshFunc();"
                    [attr.aria-label]="'Refresh last price'">
                    Refresh last price
                </a>
            </p>
        </div>
        <div class="col-lg-3 col-sm-4 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">Bid/Ask spread</p>
                <h4 *ngIf="priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.askPrice" class="rps-heading-four"
                    data-rpa-tag-id="bidAskSpread">
                    {{priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.askPrice-priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.bidPrice
                    |
                    currency:'USD':'symbol':'1.2-2'}}
                    ({{priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.askPrice !==
                    0?(bidAskSpread(priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.askPrice,priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.bidPrice)
                    | number : '1.2-2') : '&mdash;' }}%)</h4>
                <h4 *ngIf="!priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.askPrice" class="rps-heading-four"
                    data-rpa-tag-id="bidAskSpread">&mdash;</h4>
            </div>
        </div>

        <div class="col-lg-2 col-sm-4 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">Volume</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="volume">
                    {{priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.todaysVolume ?
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.todaysVolume |
                    number:'':'en') :
                    '&mdash;' }}</h4>
            </div>
        </div>
        <div class="col-lg-2 col-sm-4 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">Size</p>
                <h4 class="rps-heading-four" data-rpa-tag-id="size">
                    {{((priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.bidSize) ||
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.askSize)) ?
                    (priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.bidSize + ' X ' +
                    priceModel?.delayedPrice?.quotes[0]?.equity?.volume?.askSize) : '&mdash;'}}</h4>
            </div>
        </div>

        <div class="col-lg-2 col-sm-4 col-6">
            <div class="cell">
                <p class="rps-paragraph-two">Tick</p>
                <h4 class="rps-heading-four" *ngIf="priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange > 0"
                    data-rpa-tag-id="tick">UP</h4>
                <h4 class="rps-heading-four" *ngIf="priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange < 0"
                    data-rpa-tag-id="tick">DOWN</h4>
                <h4 class="rps-heading-four" *ngIf="!priceModel?.delayedPrice?.quotes[0]?.equity?.pricing?.netChange"
                    data-rpa-tag-id="tick">&mdash;</h4>
            </div>
        </div>
    </div>
</div>

<div *ngIf="priceModel && priceModel.profile && priceModel.profile.isETF">
    <div class="row delayedMarket">
        <div class="col-sm-12">
            <p class="rps-paragraph-one rps-grey" [innerHTML]="delayedMarket?.contentValue"></p>
        </div>
    </div>
</div>

<c11n-modal-dialog modalId="currentPriceModal" [headingText]="profileLongName" #currentPriceModalDialog>
    <div c11n-modal-dialog-body class="current-price-gap">
        <p class="rps-paragraph-one" [innerHTML]="noteText"></p>
    </div>
</c11n-modal-dialog>